import { ServiceStatusType } from '..';
import { SubStatus } from '../apiTypes';

export const parseRouteStatus = (routeStatus: SubStatus) => {
  switch (routeStatus) {
    case SubStatus.AllSailingsCancelled.valueOf():
      return ServiceStatusType.Cancelled;
    case SubStatus.Disruptions.valueOf():
      return ServiceStatusType.Disruption;
    case SubStatus.BeAware.valueOf():
      return ServiceStatusType.AtRisk;
    default:
      return ServiceStatusType.Normal;
  }
};
